import React, { useEffect } from 'react';
import { $list, $detail } from 'signals/global.signals';

// This HOC ensures the cleanup runs *only* when the wrapped component is unmounted
const withDismount = (Component, onDismount) => function WrappedComponent(props) {
  useEffect(() => () => {
    $list.reset();
    $detail.reset();
    onDismount?.(props);
  }, []);

  return <Component {...props} />;
};

export default withDismount;
